// #region IMPORTS
import { search, openSearchbar, closeSearchbar } from "./search.js";
import { animationManager } from "./animation.js";
// #endregion

// #region ELEMENT REFERENCES
const timeline = document.getElementById("line");
export const leftperiodcol = document.getElementById("left-period");
export const rightperiodcol = document.getElementById("right-period");
const timelinesettings = document.getElementById("timeline-settings-container");
// const timelineline = document.querySelector(".timeline-line");
export const lefttimelineline = document.querySelector(".timeline-line-left");
export const righttimelineline = document.querySelector(".timeline-line-right");
export const spacer = document.getElementById("spacer");
// export const leftselect = document.getElementById("leftselect");
// export const rightselect = document.getElementById("rightselect");
const leftselect = document.getElementById("leftselect");
const rightselect = document.getElementById("rightselect");
const rightoptionsList = document.getElementById("rightoptionsList");
const leftoptionsList = document.getElementById("leftoptionsList");

export const searchbutton = document.getElementById("search");
export const searchinput = document.getElementById("search-input");
export const searchopen = document.getElementById("search-open");
export const searchbar = document.getElementById("search-bar");
export const searchresults = document.getElementById("search-results");
export const searchresultsflex = document.getElementById("sr");
export const menubutton = document.getElementById("menu-button");
const menu = document.getElementById("menu");
const overlay = document.getElementById("overlay");
const overlaytitle = document.getElementById("overlay-title");
const overlaycontent = document.getElementById("overlay-content");
const kerdojel = document.getElementById("kerdojel");
// #endregion

// #region GLOBAL VARIABLES
const mindate = -775;
const colorsat = 70;
const colorlight = 65;
let marginstep = "(29.2px + 4px)";
let yearcounterl = 0;
let yearcounterr = 0;
let yearcounterb = 0;
let includer = []; // [start, end, includedl, includedr, includedb]
let lastScrollTop = 0;
let Space = 0; // 0-100 spacer value into local storage
let Left = "vilag tortenelem";
let Right = "magyar tortenelem";
let nullside;
let Year = -776;
export let leftdata = [];
export let rightdata = [];
let focusedyearindex = 1;
let resizeTimeout;
let disablescrollcalc = false; // disable scroll calculation for the timeline
export let status = 0; // default status for the timeline (-1, 0, 1) = fullleft, equal, fullright
let urlparams = {};
let isSpaceDragging = false;
// #endregion

// #region SETTERS
export function SetSpaceHeight(item) {
  const height = item.dataset.space * (spacer.value / 100);
  item.style.height = `calc(${height} * ${marginstep})`;
}
export function SetPeriodSpace(item) {
  const included = calcIncluded(item);
  const passed = calcPassed(item);
  const fullpass = item.dataset["passedl"] * 1 + item.dataset["passedr"] * 1 + item.dataset["passedb"] * 1;
  item.style.marginTop = `calc(${(item.dataset.start - mindate + 1 - fullpass) * (spacer.value / 100)} * ${marginstep} + (${marginstep} / 2 - 2px) + ${passed} * ${marginstep})`;
  item.style.height = `calc(${(Math.abs(item.dataset.start - item.dataset.end) - included) * (spacer.value / 100)} * ${marginstep} + ${included} * ${marginstep} + ${marginstep})`;
}
export function scrollToId(id) {
  const element = document.getElementById(id);
  if (element) {
    focusedyearindex = Array.from(timeline.children).indexOf(element);
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - 50;
    console.log("scroll to: ", window.pageYOffset, offsetPosition, elementPosition);

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
    element.focus();
  }
}
function SetPeriodheight(element) {
  const included = calcIncluded(element);
  element.style.height = `calc(${(Math.abs(element.dataset.start - element.dataset.end) - included) * (spacer.value / 100)} * ${marginstep} + ${included} * ${marginstep} + ${marginstep})`;
}
function Loading(isLoading, isinfo) {
  if (isLoading) {
    overlay.classList.remove("d-none");
    overlay.children[0].style.backgroundColor = "white";
    overlay.children[0].style.border = "";
    document.getElementById("overlay-close").classList.add("d-none");

    overlaycontent.classList.add("align-items-center");
    overlay.children[0].classList.add("align-items-center");
    overlaytitle.innerHTML = `<div class="message-title">Egy kis türelmet...</div>`;
    overlaycontent.innerHTML = ` <div class="loading-container">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>`;
  } else if (!isinfo) {
    overlay.classList.add("d-none");
    overlaytitle.innerHTML = ``;
    overlaycontent.innerHTML = "";
    document.getElementById("overlay-close").classList.remove("d-none");
  }
}
function showMe(e) {
  e.stopPropagation();
  document.body.style.overflow = "hidden";

  const data = JSON.parse(e.currentTarget.dataset["data"]);

  SetUrl({ year: data.year });

  overlay.classList.remove("d-none");
  if ("color-hue" in data) {
    document.getElementById("overlay-box").style.border = `solid 5px hsl(${data["color-hue"]},${colorsat}%,${colorlight}%)`;
  } else {
    document.getElementById("overlay-box").style.border = "";
  }
  document.getElementById("overlay-box").style.backgroundColor = "white";
  overlaytitle.innerHTML = `<div class="message-title">${data.title}</div>`;
  overlaycontent.classList.remove("align-items-center");
  document.getElementById("overlay-box").classList.remove("align-items-center");
  let ido = `<li class="">Év: ${IntYearToString(data.year)}</li>`;
  if (data["end-year"]) {
    ido = `<li class="">Időszak: ${IntYearToString(data.year)} - ${IntYearToString(data["end-year"])}</li>`;
  }
  let desc = "description" in data ? ConstructDescription(data.description) : "Feltöltés alatt...";
  let date = "date" in data ? `<strong><ul class="">Pontos dátum: ${data.date}</ul></strong>` : "";
  overlaycontent.innerHTML = /* HTML */ `
    <div class="data-content">
      <i>
        <ul class="m-0 ms-1 mb-1 ps-3">
          ${ido}
        </ul>
        ${date}
      </i>
      <div>${desc}</div>
    </div>
  `;
}

function IntYearToString(year) {
  if (year >= 0) return year.toString();
  else if (year < 0) return `Kr.e. ${Math.abs(year)}`;
}

function ConstructDescription(array) {
  let desc = "";
  array.forEach((item) => {
    let styles = "";
    item = item.trim();
    if (item[0] == "-") {
      if (item[1] == "-") {
        item = item.substring(2).trim();
        styles += " desc-tab-2";
      } else {
        item = item.substring(1).trim();
        styles += " desc-tab-1";
      }
    } else if (item[0] == "*") {
      item = item.substring(1).trim();
      styles += " desc-strong";
    }
    desc += `<div class="desc-item${styles}">${item}</div>`;
  });
  return desc;
}
// #endregion

// #region DYNAMIC GENERATION & DATA HANDLING
function createDate(year, data, prevyear) {
  //////////////////////////// must have
  const date = document.createElement("div");
  date.id = `${year}`;
  date.classList.add("row", "date-row", "g-0");
  date.dataset.year = year;

  const left = document.createElement("div");
  left.classList.add("date-left", "px-0");
  const identifier = `period-identity-none`;
  let middle = `
  <div class="col-auto p-0 px-1 mx-2 date-middle ${identifier}">
  <div class="card p-0 bg-primary">
  <div class="card-body p-1">
  <div class="date m-0 text-white opacity-75">${year > 0 ? year : `Kr.e. ${Math.abs(year)}`}</div>
      </div>
    </div>
  </div>`;
  const right = document.createElement("div");
  right.classList.add("date-right", "px-0");

  const space = Math.abs(year - prevyear) - 1;
  const height = space * (spacer.value / 100);
  const spaceHTML = `<div class="space" data-space=${space} style="height: calc(${height} * ${marginstep})"></div>`;

  //////////////////////////// optionals
  let flexRight = document.createElement("div");
  let flexLeft = document.createElement("div");

  data.forEach((item) => {
    if (item.type == "időszak vége") {
      if (item.side == Left) {
        middle = middle.replace("period-identity-none", "period-identity-left");
      } else if (item.side == Right) {
        middle = middle.replace("period-identity-none", "period-identity-right");
      }
    } else {
      addData(item);
      let period = false;
      let titletype = "date-title";

      if ("end-year" in item && "color-hue" in item) {
        period = true;
        titletype = "period-title";
        let col;
        let sideto;
        if (item.side === Left) {
          col = leftperiodcol;
          sideto = "left";
        } else {
          col = rightperiodcol;
          sideto = "right";
        }
        const yearcounter = calcYearCounter(yearcounterl, yearcounterr, yearcounterb);
        const periodHTML = `<div
            class="period-space ${sideto}-period-space"
            id="period-${year}-${item["end-year"]}"
            data-start=${year} 
            data-end=${item["end-year"]} 
            data-passedl=${yearcounterl} 
            data-passedr=${yearcounterr} 
            data-passedb=${yearcounterb} 
            data-includedl=0 
            data-includedr=0 
            data-includedb=0 
            style="
              width: calc(100% - ${"tab" in item ? item.tab : 0} * 2vw);
              margin-top: calc(${(year - mindate + 1 - yearcounter) * (spacer.value / 100)} * ${marginstep} + (${marginstep} / 2 - 2px) + ${yearcounter} * ${marginstep});
              background-color: hsl(${item["color-hue"]},${colorsat}%,${colorlight}%);
              height: calc(${Math.abs(year - item["end-year"])} * ${marginstep});
            "
          ></div>`;
        includer.push([year, item["end-year"], 0, 0, 0]);
        col.insertAdjacentHTML("beforeend", periodHTML);
      }
      const card = document.createElement("div");
      card.classList.add("card", "p-0");
      if (period) {
        card.style.backgroundColor = `hsl(${item["color-hue"]},${colorsat}%,${colorlight}%)`;
      }
      const cardinner = `
      <div class="card-body p-1">
        <div class="${titletype} m-0 overflow-hidden text-nowrap">${item.title}</div>
      </div>`;
      card.innerHTML = cardinner;
      delete item["_id"];
      delete item["importance"];
      delete item["__v"];
      card.dataset.data = JSON.stringify(item);
      card.onclick = (e) => showMe(e);

      if (item.side === Left) {
        flexLeft.insertAdjacentElement("beforeend", card);
      } else {
        flexRight.insertAdjacentElement("beforeend", card);
      }
    }
  });
  // nem valami optimálic, sok felesleges kódot generál, de bomba biztos
  flexLeft.classList.add("d-flex", "flex-row-reverse", "align-items-center", "gap-1");
  flexRight.classList.add("d-flex", "align-items-center", "gap-1");
  left.appendChild(flexLeft);
  right.appendChild(flexRight);
  ///////////////////////////////// append
  date.appendChild(left);
  date.insertAdjacentHTML("beforeend", middle);
  date.appendChild(right);

  timeline.insertAdjacentHTML("beforeend", spaceHTML);
  timeline.appendChild(date);
}

function addData(item) {
  if (item.side == Left) {
    leftdata.push({ year: item.year, title: item.title });
  } else if (item.side == Right) {
    rightdata.push({ year: item.year, title: item.title });
  }
}

async function getData() {
  const url = `/api/v1/timeline/${Left}/${Right}`;
  leftperiodcol.innerHTML = "";
  rightperiodcol.innerHTML = "";
  leftdata = [];
  rightdata = [];
  yearcounterl = 0;
  yearcounterr = 0;
  yearcounterb = 0;
  timeline.innerHTML = ""; // törli az összes elemet

  return axios({
    method: "get",
    url,
  }).then((response) => {
    const data = response.data.data.DATES;
    let prevyear = mindate;
    data.forEach((item) => {
      const year = item._id;
      const events = item.entries;
      createDate(year, events, prevyear);
      prevyear = year;

      // időszakoknak röhejesen sok adat számolás
      const isleft = events.some((event) => event.side == Left);
      const isright = events.some((event) => event.side == Right);

      if (isleft && isright) {
        yearcounterb++;
      } else if (isleft) {
        yearcounterl++;
      } else if (isright) {
        yearcounterr++;
      }

      const keeper = [];
      includer.forEach((item) => {
        if (year >= item[1]) {
          const period = document.getElementById(`period-${item[0]}-${item[1]}`);
          period.dataset["includedl"] = item[2];
          period.dataset["includedr"] = item[3];
          period.dataset["includedb"] = item[4];
          SetPeriodheight(period);
        } else {
          if (year > item[0]) {
            // a lényeg!
            if (isleft && isright) {
              item[4]++;
            } else if (isleft) {
              item[2]++;
            } else if (isright) {
              item[3]++;
            }
          }
          keeper.push(item);
        }
      });
      includer = keeper;
    });
    // biztonságos lezárása az időszakok számolásának
    includer.forEach((item) => {
      const period = document.getElementById(`period-${item[0]}-${item[1]}`);
      period.dataset["includedl"] = item[2];
      period.dataset["includedr"] = item[3];
      period.dataset["includedb"] = item[4];
      SetPeriodheight(period);
    });
  });
}
// #endregion

// #region GET & SET URL VALUES
export function SetUrl(params = {}, isInit = false) {
  if (!params.space) params.space = Space;
  if (!params.left) params.left = Left;
  if (!params.right) params.right = Right;
  if (!params.year) params.year = Year;
  if (!params.nullside) params.nullside = nullside;

  const url = new URL(window.location.href);
  url.pathname = `/${params.space}`;

  if (params.left === "vilag tortenelem") params.left = "vt";
  else if (params.left === "magyar tortenelem") params.left = "mt";
  else if (params.left === "magyar irodalom") params.left = "mi";
  if (params.right === "vilag tortenelem") params.right = "vt";
  else if (params.right === "magyar tortenelem") params.right = "mt";
  else if (params.right === "magyar irodalom") params.right = "mi";
  url.pathname += `/${params.left}/${params.right}`;
  if (params.nullside) url.pathname += `/${params.nullside}`;
  url.pathname += `/${params.year}`;
  // url.searchParams.set("nullside", params.nullside);
  // url.searchParams.set("left", params.left);
  // url.searchParams.set("right", params.right);
  // url.searchParams.set("space", params.space);
  if (isInit) {
    window.history.replaceState({}, "", url);
  } else {
    window.history.pushState({}, "", url);
  }
  urlparams = {};
}
function Values() {
  const url = new URL(window.location.href);
  const data = url.pathname.split("/");
  if (data.length <= 2) {
    spacer.value = Space;
    SetSelectedOption(Left, "left");
    SetSelectedOption(Right, "right");
  } else {
    try {
      const space = parseInt(data[1]);
      if (space >= 0 || space <= 100) {
        spacer.value = space;
        Space = space;
      } else throw new Error("Invalid space value");

      const left = data[2];
      if (left === "vt") Left = "vilag tortenelem";
      else if (left === "mt") Left = "magyar tortenelem";
      else if (left === "mi") Left = "magyar irodalom";
      else throw new Error("Invalid left value");
      SetSelectedOption(Left, "left");

      const right = data[3];
      if (right === "vt") Right = "vilag tortenelem";
      else if (right === "mt") Right = "magyar tortenelem";
      else if (right === "mi") Right = "magyar irodalom";
      else throw new Error("Invalid right value");
      SetSelectedOption(Right, "right");

      if (data[4] === "left" || data[4] === "right") {
        Year = parseInt(data[5]);
        nullside = data[4];
        if (nullside === "left") SetSelectedOption("null", "left");
        else SetSelectedOption("null", "right");
      } else {
        Year = parseInt(data[4]);
        nullside = null;
      }
    } catch (error) {
      console.error(error.message);
      // valami jelzést lehetne
      spacer.value = Space;
      SetSelectedOption(Left, "left");
      SetSelectedOption(Right, "right");
    }
  }
}
// #endregion

// #region MANAGERS
function columnManager(side) {
  let d, a;

  if (side === "right" && rightselect.dataset.value === "null") {
    nullside = "right";
    urlparams.nullside = "right";
  } else if (side === "left" && leftselect.dataset.value === "null") {
    nullside = "left";
    urlparams.nullside = "left";
  } else if (rightselect.dataset.value !== "null" && leftselect.dataset.value !== "null") {
    nullside = null;
    urlparams.nullside = null;
  }

  if (leftselect.dataset.value === "null" && rightselect.dataset.value !== "null") status = 1;
  else if (rightselect.dataset.value === "null" && leftselect.dataset.value !== "null") status = -1;
  else if (leftselect.dataset.value !== "null" && rightselect.dataset.value !== "null") status = 0;

  if (leftselect.dataset.value === rightselect.dataset.value) {
    // csere
    const l = Left;
    const r = Right;
    Left = r;
    Right = l;

    // adat csere
    d = "adatcsere";

    if (side === "left") {
      a = "visszabal";
    } else if (side == "right") {
      a = "visszajobb";
    }

    if (leftselect.dataset.value === "null" && side === "right") {
      // tudom hogy a bal már be volt csukva, és a jobb oldal is null lett
      // bal oldal kinyitása, jobb oldal becsukása
      SetSelectedOption(Left, "left");

      // animiáció
      a = "teljesbal";
    } else if (rightselect.dataset.value === "null" && side === "left") {
      // jobb oldal kinyitása, bal oldal becsukása
      SetSelectedOption(Right, "right");

      // animáció
      a = "teljesjobb";
    } else {
      SetSelectedOption(Left, "left");
      SetSelectedOption(Right, "right");
    }
  } else if (leftselect.dataset.value === "null") {
    if (rightselect.dataset.value == Left) {
      const l = Left;
      const r = Right;
      Left = r;
      Right = l;

      // adatcsere
      d = "adatcsere";
    } else if (rightselect.dataset.value != Right) {
      Right = rightselect.dataset.value;

      // adattöltés
      d = "jobb";
    }
    // bal becsuk
    a = "teljesjobb";
  } else if (rightselect.dataset.value === "null") {
    if (leftselect.dataset.value == Right) {
      const l = Left;
      const r = Right;
      Left = r;
      Right = l;

      // adatcsere
      d = "adatcsere";
    } else if (leftselect.dataset.value != Left) {
      Left = leftselect.dataset.value;

      // adattöltés
      d = "bal";
    }

    // jobb becsuk
    a = "teljesbal";
  } else if (leftselect.dataset.value != Left) {
    Left = leftselect.dataset.value;
    //  új adatokkal feltöltés, animáció nincs
    d = "bal";
  } else if (rightselect.dataset.value != Right) {
    Right = rightselect.dataset.value;

    // új adatokkal feltöltés, animáció nincs
    d = "jobb";
  } else if (side === "right") {
    a = "visszajobb";
  } else if (side === "left") {
    a = "visszabal";
  } else {
    // egyéb
  }

  return { d, a };
}
async function dataManager(d) {
  Loading(true, false);
  switch (d) {
    case "adatcsere":
      await getData();
      break;
    case "jobb":
      await getData();
      break;
    case "bal":
      await getData();
      break;
    default:
      break;
  }
  Loading(false, false);
}
async function fullManager(side) {
  const { d, a } = columnManager(side);
  await dataManager(d);
  SetUrl(urlparams);
  animationManager(a);
}
// #endregion

// #region INIT
async function init() {
  Values();
  const { a } = columnManager("hihihiha");
  SetUrl(urlparams, true);

  let info = false;
  if (sessionStorage.getItem("x") == null) {
    info = true;
    Loading(false, info);
    tudnivalok();
    sessionStorage.setItem("x", "Töröld ki ha szeretnéd, nem csinálok semmi érdekeset.");
  } else {
    Loading(true, info);
  }

  getData().then(() => {
    GoToFocusedYear();
    multidatarowHandler();
    respace();
    animationManager(a);
    Loading(false, info);
  });
  Loading(false, info);
}
// #endregion

// #region PERIOD CALCULATION
export function calcIncluded(item) {
  if (status == 1) return item.dataset["includedr"] * 1 + item.dataset["includedb"] * 1;
  else if (status == -1) return item.dataset["includedl"] * 1 + item.dataset["includedb"] * 1;
  else if (status == 0) return item.dataset["includedl"] * 1 + item.dataset["includedr"] * 1 + item.dataset["includedb"] * 1;
}
export function calcPassed(item) {
  if (status == 1) return item.dataset["passedr"] * 1 + item.dataset["passedb"] * 1;
  else if (status == -1) return item.dataset["passedl"] * 1 + item.dataset["passedb"] * 1;
  else if (status == 0) return item.dataset["passedl"] * 1 + item.dataset["passedr"] * 1 + item.dataset["passedb"] * 1;
}
function calcYearCounter(l, r, b) {
  if (status == 1) return r + b;
  else if (status == -1) return l + b;
  else if (status == 0) return l + r + b;
}
function scroll(e) {
  if (!disablescrollcalc) {
    // timelineSettingsScroll();
    //updateFocusedYear();
  }
}
// #endregion

// #region MENU && SCROLL
function timelineSettingsScroll() {
  let currentScroll = window.scrollY || document.documentElement.scrollTop;

  if (currentScroll > lastScrollTop) {
    timelinesettings.style.top = "-60px";
    hideMenu();
    closeSearchbar();
  } else {
    timelinesettings.style.top = "0";
  }
  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
}
function showmenu() {
  menu.classList.remove("hide");
  menu.classList.remove("d-none");
}
function hideMenu() {
  menu.classList.add("hide");
}
function togglemenu(e) {
  e.stopPropagation();
  if (menu.classList.contains("hide") || menu.classList.contains("d-none")) {
    showmenu();
  } else {
    hideMenu();
  }
}
// #endregion

// #region FOCUS YEAR
function GoToFocusedYear() {
  try {
    const year = parseInt(getFocusedYear());
    // megkeresni azt az elemet aminél a year egyezik és oda is navigál
    if (year) {
      setTimeout(() => {
        const element = document.getElementById(year);
        document.documentElement.scrollTop = element.offsetTop - 50;
        focusedyearindex = Array.from(timeline.children).indexOf(element);
      }, 0);
    }
  } catch (error) {
    // jelzés a felhasználónak, hogy nem található az elem
    console.error("Invalid year in URL:", error.message);
    Year = -776;
    SetUrl({ year: -776 });
  }
}

function getFocusedYear() {
  const url = new URL(window.location.href);
  return url.pathname.split("/").pop();
}
// Megkeresi a legközelebbi évet a timelineon, és visszaadja az id-t, és az évet
function setFocusedYear() {}
// #endregion

// #region AMIKOR NEM FÉR KI EGY SORBA
function multidatarowHandler() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const left = document.querySelectorAll(".date-left");
    const middle = document.querySelectorAll(".date-middle");
    const right = document.querySelectorAll(".date-right");
    for (let i = 0; i < middle.length; i++) {
      sideShrinker(left[i], middle[i]);
      sideShrinker(right[i], middle[i]);
    }
  }, 800);
}
function showMore(e, arr, mid) {
  e.stopPropagation();
  document.body.style.overflow = "hidden";

  overlay.classList.remove("d-none");
  overlay.children[0].style.backgroundColor = "white";
  overlay.children[0].style.border = "";
  overlaytitle.innerHTML = "";
  overlaycontent.innerHTML = "";
  overlaycontent.classList.add("align-items-center");
  overlay.children[0].classList.add("align-items-center");

  const flex = arr.map((item) => item.outerHTML).join("");
  if (flex.includes("period-title")) {
    const color = [...flex.matchAll(/style="background-color: (rgb\(\d+, \d+, \d+\));"/g)].map((match) => match[1]);
    overlay.children[0].style.backgroundColor = color[0];
  }
  overlaytitle.insertAdjacentElement("afterbegin", mid);
  arr.forEach((item) => {
    item.onclick = (e) => showMe(e);
    overlaycontent.insertAdjacentElement("beforeend", item);
  });
}
function hideOverlay() {
  if (!overlaytitle.innerHTML.includes("Egy kis türelmet")) {
    overlay.classList.add("d-none");
  }
  document.body.style.overflow = "";
}
function sideShrinker(item, middle) {
  const sidecont = item ? item.children[0] : null;
  if (!sidecont) return;

  // item = left vagy right oldal container
  const i = Array.from(sidecont.children);
  if (i.length > 1) {
    let text;
    for (const x of i) {
      text = x.querySelector(".date-title") || x.querySelector(".period-title");
      if (text && text.scrollWidth > text.clientWidth * 1.5) {
        // ide az összegyúrt elemet
        const bigguy = sidecont.children[0].cloneNode(true);
        bigguy.classList.add("tight-date");
        bigguy.children[0].insertAdjacentHTML(
          "beforeend",
          /* HTML */
          ` <svg width="14" height="14" class="card-image" style="margin-bottom: 1px">
            <use href="/icons/icons.svg#3dot" />
          </svg>`
        );
        bigguy.children[0].classList.add("card-body", "d-flex", "align-items-center", "gap-1");
        const innerelements = Array.from(sidecont.children).map((item) => item.cloneNode(true));
        bigguy.onclick = (e) => showMore(e, innerelements, middle.cloneNode(true));
        sidecont.innerHTML = ""; // kiüríti az oldalt
        sidecont.insertAdjacentElement("afterbegin", bigguy);
        break;
      } else {
        // ha be volt csukva, akkor ki is lehessen nyitni?
        // nah refresh majd megoldja
      }
    }
  }
}
// #endregion

// #region SPACE
// A térközök újraszámolása (évek közötti távolságok, időszakok magassága és kezdő pozíciója)
function respace() {
  Space = spacer.value;

  const spaces = document.querySelectorAll(".space");
  const periods = document.querySelectorAll(".period-space");
  let height;
  height = document.querySelector(".date-left").getBoundingClientRect().height;
  if (height == 0 || height == null) {
    height = document.querySelector(".date-right").getBoundingClientRect().height;
  }
  marginstep = `(${height}px + 4px)`;
  spaces.forEach((item) => {
    SetSpaceHeight(item);
  });
  periods.forEach((item) => {
    SetPeriodSpace(item);
  });
}

// Az előre megírt térközöknek az onclick eseménye
function prespace(item) {
  spacer.value = parseInt(item.textContent);
  const year = getFocusedYear();
  if (spacer.value != Space) SetUrl({ space: spacer.value });
  disablescrollcalc = true;
  setTimeout(() => {
    document.getElementById(year).scrollIntoView({ behavior: "smooth" });
    disablescrollcalc = false;
  }, 500);
  respace();
}

// A térköz csúszkának az onchange eseménye
function space() {
  const year = getFocusedYear();
  disablescrollcalc = true;
  setTimeout(() => {
    document.getElementById(year).scrollIntoView({ behavior: "smooth" });
    disablescrollcalc = false;
  }, 500);
  respace();
}

function endDrag() {
  if (isSpaceDragging) {
    isSpaceDragging = false;
    SetUrl({ space: spacer.value });
  }
}
// #endregion

// #region CUSTOM SELECT
// A saját select adatainak kezelése
function SetSelectedOption(value, side) {
  if (side === "left") {
    Array.from(leftoptionsList.children).forEach((opt) => opt.classList.remove("selected"));

    leftselect.dataset.value = value;
    let text = "Error";
    Array.from(leftoptionsList.children).forEach((option) => {
      if (option.dataset.value == value) {
        option.classList.add("selected");
        text = option.innerHTML;
        return;
      }
    });
    leftselect.textContent = text;
  } else if (side === "right") {
    Array.from(rightoptionsList.children).forEach((opt) => opt.classList.remove("selected"));

    rightselect.dataset.value = value;
    let text = "Error";
    Array.from(rightoptionsList.children).forEach((option) => {
      if (option.dataset.value == value) {
        option.classList.add("selected");
        text = option.innerHTML;
        return;
      }
    });
    rightselect.textContent = text;
  }
}
// A saját select direkt oncick eseménye
async function OptionClick(option, side) {
  if (side === "left") {
    Array.from(leftoptionsList.children).forEach((opt) => opt.classList.remove("selected"));
    option.classList.add("selected");
    leftselect.textContent = option.textContent;
    leftselect.dataset.value = option.dataset.value;
    leftoptionsList.style.display = "none";
    await fullManager("left");
  } else if (side === "right") {
    Array.from(rightoptionsList.children).forEach((opt) => opt.classList.remove("selected"));
    option.classList.add("selected");
    rightselect.textContent = option.textContent;
    rightselect.dataset.value = option.dataset.value;
    rightoptionsList.style.display = "none";
    await fullManager("right");
  }
}
// #endregion

// #region TUDNIVALOK LAYOUT
function tudnivalok() {
  document.body.style.overflow = "hidden";

  overlay.classList.remove("d-none");
  overlay.children[0].style.backgroundColor = "white";
  overlay.children[0].style.border = "4px solid var(--bs-primary)";

  overlaytitle.innerHTML = /* HTML */ `<div class="d-flex flex-row align-items-center gap-2">
    <div class="rounded-circle bg-primary ">
      <svg width="50" height="50" class="p-1 rounded-circle" style="filter: invert(1)">
        <use href="/icons/icons.svg#qu" />
      </svg>
    </div>
    <div class="h2">Közérdekű információk</div>
  </div>`;
  overlaycontent.classList.add("align-items-center");
  overlay.children[0].classList.add("align-items-center");
  overlaycontent.innerHTML = /* HTML */ ` <div class="tudnivalok">
    <div class="info-bigbigbig">Üdv az Idővonal érettségihez oldalon!!! 🎉🎉</div>
    <div class="info-title">Miről szól ez az oldal?</div>
    <div class="info-text">Ez egy idővonal, amely a középszintű érettségi követelmények magyar- és világ történelmét szemlélteti egymás mellett.</div>
    <hr />
    <div class="info-text">Ha valamit nem értesz nyomj rá az egyik eseményre, hogy kicsit bővebben lásd miről van szó.</div>
    <hr />
    <div class="info-text">Lehetőséged van a csúszkával vagy a menüben beállítani mennyire legyenek élethűek a távolságok az egyes évszámok között.</div>
    <div class="info-danger">Az idővonal csak középszintű anyagot tartalmaz.</div>
    <div class="info-title">Ki vagyok én?</div>
    <div class="info-text">Egy érettségiző diák, aki szeretné megkönnyíteni saját és diáktársai életét.</div>
    <div class="info-title">Mit jelentenek a színek?</div>
    <div class="info-text">A színeket többnyire hasraütésszerűen határoztam meg, de íme pár logikus gondolat.</div>
    <ul class="mt-1">
      <li class="info-text"><span class="blue">Kék:</span> vagy nem olyan fontos vagy tél vagy demokrácia vagy semleges esemény.</li>
      <li class="info-text"><span class="green">Zöld:</span> pozítív dolgok, stabilitás, fellendülés.</li>
      <li class="info-text"><span class="red">Piros:</span> primitív dolgok vagy elképesztő kegyetlenkedések, diktatúrák, háborúk.</li>
      <li class="info-text"><span class="yellow">Sárga:</span> leginkább össze-vissza, néha gazdagságot jelöli, néha az átfordulást jóból rosszba.</li>
    </ul>
    <div class="info-title">Ha további kérdésed van sajnos nem tudod feltenni.</div>
    <div class="info-text">Ha esetleg ismersz szólj, ha helyesírási hibát vagy valami egyebet módosítanál az oldalon.</div>
    <div class="info-end">Információs szekció vége. Irány a sok évszám!</div>
    <div class="info-text">Ha tetszik az oldal, oszd meg másokkal is, hogy minél több emberhez eljusson.</div>
    <div class="info-mini">Legutolsó módosítás dátuma: 2025.05.03.</div>
  </div>`;
}
// #endregion

// #region HISTORY
function loadHistory(e) {
  GoToFocusedYear();
}
// #endregion

// #region EVENTS
document.addEventListener("DOMContentLoaded", init);
window.addEventListener("scroll", (e) => scroll(e));
window.addEventListener("resize", () => {
  multidatarowHandler();
  respace();
});
document.addEventListener("click", (e) => {
  hideMenu();
  hideOverlay();
  if (!e.target.closest(".select-wrapper")) {
    leftoptionsList.style.display = "none";
    rightoptionsList.style.display = "none";
  }
});
window.addEventListener("popstate", (e) => loadHistory(e));

menubutton.addEventListener("click", (e) => togglemenu(e));
menu.addEventListener("click", (e) => e.stopPropagation());
document.getElementById("overlay-box").addEventListener("click", (e) => e.stopPropagation());
document.getElementById("overlay-close").addEventListener("click", hideOverlay);
searchbutton.addEventListener("click", search);
searchinput.addEventListener("keydown", (e) => (e.key == "Enter" ? search() : () => {}));
searchinput.addEventListener("input", search);
searchopen.addEventListener("click", openSearchbar);
document.getElementById("search-close").addEventListener("click", closeSearchbar);
document.querySelectorAll(".prespace").forEach((item) => item.addEventListener("click", () => prespace(item)));
spacer.addEventListener("input", space);
spacer.addEventListener("mousedown", () => (isSpaceDragging = true));
spacer.addEventListener("touchstart", () => (isSpaceDragging = true));
spacer.addEventListener("mouseup", endDrag);
spacer.addEventListener("touchend", endDrag);
spacer.addEventListener("mouseleave", endDrag);
leftselect.addEventListener("click", () => (leftoptionsList.style.display = leftoptionsList.style.display === "flex" ? "none" : "flex"));
rightselect.addEventListener("click", () => (rightoptionsList.style.display = rightoptionsList.style.display === "flex" ? "none" : "flex"));
Array.from(leftoptionsList.children).forEach((option) => option.addEventListener("click", async () => await OptionClick(option, "left")));
Array.from(rightoptionsList.children).forEach((option) => option.addEventListener("click", async () => await OptionClick(option, "right")));
kerdojel.addEventListener("click", tudnivalok);
// #endregion
